import programApi from '@/api/program'
const programTypesData = require('./data/programTypes.json')
const programTypesLAData = require('./data/programTypesLA.json')

const programModel = {
  title: '',
  title_otherText: '',
  organization: 0
}

const state = {
  newProgram: Object.assign({}, programModel),
  editProgram: false,
  programTypes: programTypesData.items,
  programTypesLA: programTypesLAData.items,

  viewProgramPending: false,
  viewProgramFailure: false,
  viewProgramSuccess: [],

  createProgramPending: false,
  createProgramFailure: false,
  createProgramSuccess: false,

  updateProgramPending: false,
  updateProgramFailure: false,
  updateProgramSuccess: false,

  deleteProgramPending: false,
  deleteProgramFailure: false,
  deleteProgramSuccess: false

}

const getters = {
  viewProgramPending: state => state.viewProgramPending,
  viewProgramFailure: state => state.viewProgramFailure,
  viewProgramSuccess: state => state.viewProgramSuccess,

  getCreateProgram: state => state.newProgram,
  createProgramPending: state => state.createProgramPending,
  createProgramFailure: state => state.createProgramFailure,
  createProgramSuccess: state => state.createProgramSuccess,

  getEditProgram: state => state.editProgram,
  getUpdateProgramPending: state => state.updateProgramPending,
  getUpdateProgramFailure: state => state.updateProgramFailure,
  getUpdateProgramSuccess: state => state.updateProgramSuccess,

  getProgramTypes: state => state.programTypes,
  getProgramTypesLA: state => state.programTypesLA
}

const actions = {
  async getProgramRecords ({ commit, state }, payload) {
    commit('SET_PROGRAM_STATE', { field: 'viewProgramPending', value: true })

    let response = await programApi.getPrograms(payload)

    commit('SET_PROGRAM_STATE', { field: 'viewProgramPending', value: false })

    if (response.status !== 200) {
      // TO DO - Is there always a body.error?
      commit('SET_PROGRAM_STATE', { field: 'viewProgramFailure', value: response.body.error })
      return
    }

    commit('SET_PROGRAM_STATE', { field: 'viewProgramSuccess', value: response.body })
  },

  async createProgram ({ commit, state }, payload) {
    commit('SET_PROGRAM_STATE', { field: 'createProgramPending', value: true })

    let response = await programApi.createProgram(payload)

    commit('SET_PROGRAM_STATE', { field: 'createProgramPending', value: false })

    if (response.status !== 200) {
      // TO DO - Is there always a body.error?
      commit('SET_PROGRAM_STATE', { field: 'createProgramFailure', value: response.body.error })
      return
    }

    commit('ADD_PROGRAM_IN_LIST', response.body)
    commit('SET_PROGRAM_STATE', { field: 'createProgramSuccess', value: response.body })
    // commit('RESET_CREATE_USERMEMBER')
    return response.body
  },
  async updateProgram ({ commit, state }, payload) {
    commit('SET_PROGRAM_STATE', { field: 'updateProgramPending', value: true })

    let response = await programApi.updateProgram(payload)

    commit('SET_PROGRAM_STATE', { field: 'updateProgramPending', value: false })

    if (response.status !== 200) {
      commit('SET_PROGRAM_STATE', { field: 'updateProgramFailure', value: response.body })
      return
    }

    commit('ADD_PROGRAM_IN_LIST', response.body)
    commit('SET_PROGRAM_STATE', { field: 'updateProgramSuccess', value: response.body })
  },

  async deleteProgram ({ commit, state }, payload) {
    commit('SET_PROGRAM_STATE', { field: 'updateProgramPending', value: true })

    let response = await programApi.deleteProgram(payload)

    commit('SET_PROGRAM_STATE', { field: 'updateProgramPending', value: false })

    if (response.status !== 200) {
      commit('SET_PROGRAM_STATE', { field: 'updateProgramFailure', value: response.body })
      return
    }
    commit('DELETE_PROGRAM_FROM_LIST', response.body)
    commit('SET_PROGRAM_STATE', { field: 'updateProgramSuccess', value: response.body })
  }
}

const mutations = {

  RESET_VIEW_PROGRAM (state) {
    state.viewProgramSuccess = []
  },
  DELETE_PROGRAM_FROM_LIST (state, response) {
    const existingIndex = state.viewProgramSuccess.findIndex((r) => r.id === response.id)
    if (existingIndex >= 0) {
      state.viewProgramSuccess.splice(existingIndex, 1)
    } else {
      console.log('did not find deleted program record in the program list')
    }
  },
  ADD_PROGRAM_IN_LIST (state, response) {
    const existingIndex = state.viewProgramSuccess.findIndex((r) => r.id === response.id)

    // Update list with the returned record
    if (existingIndex >= 0) {
      state.viewProgramSuccess.splice(existingIndex, 1, response)
    } else {
      state.viewProgramSuccess.push(response)
      // TO DO - Sort?
    }
  },
  RESET_CREATE_PROGRAM (state) {
    state.newProgram = Object.assign({}, programModel)
    state.createProgramPending = false
    state.createProgramFailure = false
    state.createProgramSuccess = false
  },
  RESET_UPDATE_PROGRAM (state) {
    state.editProgram = false
    state.updateProgramPending = false
    state.updateProgramFailure = false
    state.updateProgramSuccess = false
  },
  SET_PROGRAM_STATE (state, payload) {
    const { field, value } = payload
    state[field] = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/program.js